/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * last_week object
 * @export
 * @interface GetFwLeaderboardsCorporationsLastWeekLastWeek
 */
export interface GetFwLeaderboardsCorporationsLastWeekLastWeek {
    /**
     * Amount of kills
     * @type {number}
     * @memberof GetFwLeaderboardsCorporationsLastWeekLastWeek
     */
    amount?: number;
    /**
     * corporation_id integer
     * @type {number}
     * @memberof GetFwLeaderboardsCorporationsLastWeekLastWeek
     */
    corporationId?: number;
}

/**
 * Check if a given object implements the GetFwLeaderboardsCorporationsLastWeekLastWeek interface.
 */
export function instanceOfGetFwLeaderboardsCorporationsLastWeekLastWeek(value: object): value is GetFwLeaderboardsCorporationsLastWeekLastWeek {
    return true;
}

export function GetFwLeaderboardsCorporationsLastWeekLastWeekFromJSON(json: any): GetFwLeaderboardsCorporationsLastWeekLastWeek {
    return GetFwLeaderboardsCorporationsLastWeekLastWeekFromJSONTyped(json, false);
}

export function GetFwLeaderboardsCorporationsLastWeekLastWeekFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsCorporationsLastWeekLastWeek {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'corporationId': json['corporation_id'] == null ? undefined : json['corporation_id'],
    };
}

export function GetFwLeaderboardsCorporationsLastWeekLastWeekToJSON(json: any): GetFwLeaderboardsCorporationsLastWeekLastWeek {
    return GetFwLeaderboardsCorporationsLastWeekLastWeekToJSONTyped(json, false);
}

export function GetFwLeaderboardsCorporationsLastWeekLastWeekToJSONTyped(value?: GetFwLeaderboardsCorporationsLastWeekLastWeek | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'corporation_id': value['corporationId'],
    };
}

